import { Question, QuestionFormResponse } from '../types/questionnaire.types';

export const formatResponses = (
  questions: Question[],
  responses: Record<string, string>
): QuestionFormResponse[] => {
  return questions.map((question) => {
    const answer = responses[question.id] || '';

    if (question.type === 'multiple_choice') {
      const selectedAnswer = question.answers?.find((a) => a.id === answer);
      return {
        questionId: question.id,
        questionType: 'multiple_choice',
        response: {
          answerId: answer,
          answerText: selectedAnswer?.text || '',
        },
      };
    }

    if (question.type === 'true_false') {
      return {
        questionId: question.id,
        questionType: 'true_false',
        response: {
          value: answer === 'true',
        },
      };
    }

    if (question.type === 'essay') {
      return {
        questionId: question.id,
        questionType: 'essay',
        response: {
          text: answer || '',
        },
      };
    }

    if (question.type === 'multiple_choice_checkbox') {
      const selectedIds = answer ? answer.split(',') : [];
      const answersArray = selectedIds.map((id) => {
        const selectedAnswer = question.answers?.find((a) => a.id === id);
        return {
          answerId: id,
          answerText: selectedAnswer?.text || '',
        };
      });

      return {
        questionId: question.id,
        questionType: 'multiple_choice_checkbox',
        response: {
          answers: answersArray,
        },
      };
    }

    if (question.type === 'matrix_scale') {
      const matrixAnswers = answer ? JSON.parse(answer) : {};
      const matrixAnswersArray = Object.keys(matrixAnswers).map((rowId) => {
        const row = question.matrixRows?.find((r) => r.id === rowId);
        const selectedAnswer = question.matrixColumns?.find(
          (col) => col.id === matrixAnswers[rowId]
        );
        return {
          rowId,
          rowText: row?.text || '',
          answerId: matrixAnswers[rowId],
          answerText: selectedAnswer?.text || '',
        };
      });

      return {
        questionId: question.id,
        questionType: 'matrix_scale',
        response: {
          matrixAnswers: matrixAnswersArray,
        },
      };
    }

    if (question.type === 'ranking') {
      const rankedAnswers = answer ? JSON.parse(answer) : [];
      return {
        questionId: question.id,
        questionType: 'ranking',
        response: {
          rankedAnswers,
        },
      };
    }

    return {
      questionId: question.id,
      questionType: 'essay',
      response: {
        text: '',
      },
    };
  });
};
